var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { AntdSchemaFieldAdaptor, pickFormItemProps } from '@formily/antd';
import { createVirtualBox } from '@formily/react-schema-renderer';
import { Row } from 'antd';
export var FormGridRow = createVirtualBox('grid-row', function (props) {
    var title = props.title, label = props.label;
    var grids = React.createElement(Row, __assign({}, props), props.children);
    if (title || label) {
        return (React.createElement(AntdSchemaFieldAdaptor, __assign({}, pickFormItemProps(props)), grids));
    }
    return grids;
});
export default FormGridRow;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/antd-components/esm/form-grid-row/index.js
// module id = 6297
// module chunks = 0